<div class="dialog-popup" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type">
  @if (data.image) {
    <img class="e-invoice-image" [src]="data.image" [alt]="data.image_alt">
  }
  @if (data.title) {
    <h2 mat-dialog-title [innerHTML]="data.title"></h2>
  }
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="submit()" [attr.aria-busy]="saving()">
      @if (data.body) {
        <div class="mb-l" [innerHTML]="data.body"></div>
      }
      @if (success()) {
        <p role="status" class="notification info mb-l p-m mt-0">Vielen Dank für die Bestätigung Ihrer E-Mail-Adresse. Sie können diese auf der Seite <a class="link-on-success" href="/stammdaten"><strong>Stammdaten</strong></a> jederzeit einsehen und bei Bedarf anpassen.</p>
      }
      <mat-form-field appearance="outline">
        <mat-label>E-Mail</mat-label>
        <input matInput type="email" name="eInvoiceEmail" formControlName="eInvoiceEmail" autocomplete="email" required>
        @if (success()) {
          <span matSuffix class="e-invoice-confirmed" role="img" aria-label="E-Mail-Adresse erfolgreich bestätigt">
            <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
              <circle cx="10" cy="10" r="10" fill="currentColor"/>
              <path d="m6 10 2.5 2.5L14 7" fill="none" stroke="#fff" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        }
        @if (form.controls.eInvoiceEmail.hasError('required')) {
          <mat-error>Bitte geben Sie eine E-Mail-Adresse ein.</mat-error>
        } @else if (form.controls.eInvoiceEmail.hasError('email')) {
          <mat-error>Bitte geben Sie eine gültige E-Mail-Adresse ein.</mat-error>
        }
      </mat-form-field>
<!--      <mat-checkbox formControlName="notify">-->
<!--        Benachrichtigungen bei neuen E-Rechnungen ebenfalls an diese E-Mail-Adresse senden.-->
<!--      </mat-checkbox>-->
      @if (error()) {
        <p class="text-danger" role="alert">{{ error() }}</p>
      }
      <mat-dialog-actions>
        @if (success()) {
          <button mat-flat-button type="button" [mat-dialog-close]="true">SCHLIESSEN</button>
        } @else {
          <button mat-flat-button type="submit" [disabled]="saving()">
            {{ saving() ? 'WIRD GESPEICHERT...' : 'JETZT BESTÄTIGEN' }}
          </button>
          <button mat-button type="button" [mat-dialog-close]="false" [disabled]="saving()">SPÄTER ERINNERN</button>
        }
      </mat-dialog-actions>
      @if (data.disclaimer) {
        <div class="e-invoice-disclaimer mb-l" [innerHTML]="data.disclaimer"></div>
      }
    </form>
  </mat-dialog-content>
</div>
